import { useCallback } from 'react';
import { connect } from 'react-redux';

import { siteboardAction } from '../actions/defaultActions';
import { SET_USER_ROLE_INFO_DIALOGUE_SHOWING } from '../actions/types';

import PopupWindow from './PopupWindow';

const UserRoleInfoDialogue = ({ siteboardAction }) => {
  const closeDialogue = useCallback(() => {
    siteboardAction(SET_USER_ROLE_INFO_DIALOGUE_SHOWING, { isOpen: false });
  }, [siteboardAction]);

  return (
    <>
      <PopupWindow title={process.env.REACT_APP_WEBSITE_NAME + ' Roles'} closeDialogue={closeDialogue} bgStyle='bg-[#333333]'>
        <div className='flex flex-col gap-4 text-white max-w-[400px]'>
          <div>{process.env.REACT_APP_WEBSITE_NAME} has project roles and account roles that define what actions a user is authorized to take.</div>
          {/*<div>
            <h2 className='font-bold text-[1.4em]'>Project Viewer</h2>
            <div>Can view project schedules but not create or edit them.</div>
          </div>*/}
          <div>
            <h2 className='font-bold text-[1.4em]'>Project Member</h2>
            <div>Can create, edit, publish, unpublish project schedules.</div>
          </div>
          <div>
            <h2 className='font-bold text-[1.4em]'>Project Admin</h2>
            <div>Can assign project members and edit project settings and schedules.</div>
          </div>
          <div>
            <h2 className='font-bold text-[1.4em]'>Account Manager</h2>
            <div>Can create and edit projects, and assign project members and admins to all projects within the account.</div>
          </div>
          <div>
            <h2 className='font-bold text-[1.4em]'>Account Owner</h2>
            <div>Can add Account Managers, manage billing, and view/edit all projects within their own account.</div>
          </div>
        </div>
      </PopupWindow>
    </>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
}};
export default connect(mapStateToProps, {siteboardAction})(UserRoleInfoDialogue);
